import { render, staticRenderFns } from "./not-qualified-reason.vue?vue&type=template&id=a6d170ee&"
import script from "./not-qualified-reason.vue?vue&type=script&lang=js&"
export * from "./not-qualified-reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports